import { TActions } from '../../../AppModulesWrapper';

import { SET_PAYMENT_PROCESSING_DATA, SET_PAYMENT_PROCESSING_STATUS } from '../../actions/paymentProcessing';
import { RESET_STATE } from '../../actions/resetState';
import { TPaymentProcessingState } from '../../types/reducers/paymentProcessing';

const DEFAULT_STATE: TPaymentProcessingState = {};

export const paymentProcessing = (state: TPaymentProcessingState = DEFAULT_STATE, action: TActions) => {
  switch (action.type) {
    case SET_PAYMENT_PROCESSING_DATA: {
      const { type, ...data } = action.payload;

      return {
        ...state,
        [type]: {
          ...data,
          status: null,
        },
      };
    }

    case SET_PAYMENT_PROCESSING_STATUS: {
      const { type, status } = action.payload;

      return {
        ...state,
        [type]: {
          ...state[type],
          status,
        },
      };
    }

    case RESET_STATE:
      return {
        ...DEFAULT_STATE,
      };

    default:
      return state;
  }
};
